import React, { useContext, useEffect, useState } from "react";
import {
  AppBar,
  IconButton,
  Toolbar,
  Drawer,
  Button,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import {
  Menu,
  AccountCircle,
  Brightness4,
  Brightness7,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./Styles";
import { Link } from "react-router-dom";
import { Sidebar } from "..";
import { ColorModeContext } from "../../utils/ToggleDarkmode";
import Search from './../Search/Search';
import { fetchToken, CreateSessionId, moviesApi } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { setUser, userSelector } from "../../features/auth";
const NavBar = () => {
  const dispatch = useDispatch();
  const {isAuthenticated, user} = useSelector(userSelector);
  const [mobileOpen, setMobileOpen] = useState(false);
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const theme = useTheme();

  const colormode = useContext(ColorModeContext)
  

  const token = localStorage.getItem("request_token");
  const sessionIdForLocalStorage = localStorage.getItem("session_id");

  useEffect(() => {
    const logInUser = async () => {
      if (token) {
        if (sessionIdForLocalStorage) {
          const { data: userData } = await moviesApi.get(`/account?session_id=${sessionIdForLocalStorage}`);

          dispatch(setUser(userData));
        }
        else {
          const sessionId = await CreateSessionId();
          const { data: userData } = await moviesApi.get(`/account?session_id=${sessionId}`);

          dispatch(setUser(userData))
        }
      }
    }

    logInUser();
  }, [token])

  return (
    <>
      <AppBar position="fixed">
        <Toolbar className={classes.toolbar}>
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              style={{ outline: "none" }}
              onClick={() => setMobileOpen((prevMobileOpen) => !prevMobileOpen)}
              className={classes.menuButton}
            >
              <Menu />
            </IconButton>
          )}
          <IconButton color="inherit" sx={{ ml: 1 }} onClick={colormode.toggleColorMode}>
            {theme.palette.mode === "dark" ? <Brightness7 /> : <Brightness4 />}
          </IconButton>

          {!isMobile && <Search />}
          <div className="">
            {!isAuthenticated ? (
              <Button color="inherit" to onClick={fetchToken}
              >
                LOGIN &nbsp; <AccountCircle />
              </Button>
            ) : (
                <Link className={classes.linkButton}  to={`/profile/${user.id}`}>
              <Button
                color="inherit"
                className={classes.linkButton}
                onClick={() => {}}>
                {!isMobile && <>My Movies &nbsp; </>}
                <Avatar
                  style={{ width: 30, height: 30 }}
                    alt="Profile"
                  src={
                    "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541"
                  }
                ></Avatar>
                  </Button>
                  </Link>
            )}
          </div>
          {isMobile && <Search />}
        </Toolbar>
      </AppBar>
    
      <div className="">
      <nav className={classes.drawer}>
        {isMobile ? (
          <Drawer
            variant="temporary"
            anchor="right"
                      open={mobileOpen}
                      onClose={() => setMobileOpen((prevMobileOpen) => !prevMobileOpen)}
            classes={{ paper: classes.drawerPaper }}
            ModalProps={{ keepMounted: true }}
          >
            <Sidebar setMobileOpen={setMobileOpen} />
          </Drawer>
        ) : (
          <Drawer
            className={{ paper: classes.drawerPaper }}
            variant="permanent"
            open
          >
            <Sidebar setMobileOpen={setMobileOpen} />
          </Drawer>
        )}
        </nav>
        </div>
    </>
  );
};

export default NavBar;
